import React from 'react';
import Item from './Item'

class PrivilegeMultiselect extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value || "",
            items: props.items || [],
            privilegesTree: []
        };
    }

    // Events
	onDirt = (e) => {
		this.props.onDirt && this.props.onDirt();
	}
    
    // Private
    _handleChange = (id, selected) => {
        let selectedValues = this.state.value;

        this.onDirt();
        
        // Selected
        if (selected && !selectedValues.includes(id)) {
            selectedValues.push(id);
        }
        // Deselected
        else if (!selected && selectedValues.includes(id)) {
            var idx = selectedValues.indexOf(id);

            if (idx !== -1) {
                selectedValues.splice(idx, 1)
            }
        }

        this.state.privilegesTree.forEach((pte => {
            if (pte.parent === id) {
                this._handleChange(pte.id, selected);
            }
        }));

        this.setState({ value: selectedValues }, function () {
            this.forceUpdate();
        });
    }

    _parseParentsTree(resources, parent = "") {
        let tree = [];

        resources.forEach((r) => {
            this._parseParentsTree(r.childs, r.resourceCode).forEach((e) => {
                tree.push(e);
            });

            // Dont add root elements
            if (parent !== "")
                tree.push({
                    parent: parent,
                    id: r.resourceCode
                });

            r.privileges.forEach((p) => {
                tree.push({
                    parent: r.resourceCode,
                    id: p.privilegeCode
                });
            });
        });

        return tree;
    }

    _renderItems(resource, level = 0) {
        const self = this;
        let items = [];
        let className = "item level-" + level;

        items.push(
            <div key={resource.resourceCode}>
                <div className={className}>
					<span className="label label-info">
						<strong>{resource.resourceName}</strong>
					</span>
                </div>
            </div>
        );

        resource.childs.forEach((rc) => {
            items.push(this._renderItems(rc, level + 1));
        })

        if (resource.privileges && resource.privileges.length > 0)
            items.push(
                resource.privileges.map((p, pi) => {
                    return <Item
                        key={resource.resourceCode + p.privilegeCode}
                        text={p.privilegeName}
                        id={p.privilegeCode}
                        selected={this.state.value.includes(p.privilegeCode)}
                        onChange={self._handleChange}
                        disabled={self.props.disabled}
                        level={level + 1} />;
                })
            );

        return items;
    }

    // React
    shouldComponentUpdate(nextProps, nextState) {
        return (
            nextProps.value !== this.state.value
            || nextState.value !== this.state.value
            || nextProps.items !== this.props.items);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.items instanceof Array) {
            this.setState({
                privilegesTree: this._parseParentsTree(nextProps.items),
                value: nextProps.value,
                items: nextProps.items
            });
        }
    }

    render() {
        const self = this;
        const defaultHeight = "250px";
        const containerStyle = { 
            height: this.props.height || defaultHeight,
            marginBottom: "10px"
        };

        return (
            <div className="multiselect privilege-multiselect" style={containerStyle}>
                {
                    this.state.items.map(function (item, i) {
                        return self._renderItems(item);
                    })
                }
            </div >
        )
    }
}

PrivilegeMultiselect.defaultProps = {
	formControl: true,
	managed: false
};

export default PrivilegeMultiselect;



// WEBPACK FOOTER //
// ./src/areas/admin/roleSetup/roleInfo/PrivilegeMultiselect.js